"use client";

import styles from "./styles.module.scss";
import cn from "clsx";
import { useEffect } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import DownloadCTASticky from "./DownloadCTASticky/DownloadCTASticky";
import EnrollNowButton from "./EnrollNowButton/EnrollNowButton";
import { getGlobalStateValue } from "@/context/utils";
import { usePathname } from "next/navigation";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import RightArrowNew from "@/SvgIcons/RightArrowNew";
import RightArrow from "@/SvgIcons/RightArrow";
import { useHeaderLogo } from "@/features/site-chrome/view/useHeaderLogo";
import { IMAGE_ASSETS } from "@/constants/images";
import {
  AI_Phone_Slug,
  second_Phone_Slug,
} from "@/components/LandingPageMBA/MbaLandingPageHeader/utils";

export default function LandingPageHeader({
  data,
  isEnrollNowDisabled = false,
}) {
  const isProgramListPage = data?.isProgramListPage;
  const headerFooterData = data?.headerFooterData || {};
  const { header, templateType, webinar, isCROPage, headerMenu } =
    headerFooterData;
  const device = data?.device;
  const isMobile = device === "mobile";
  const slug = data?.slugs?.join("/");
  let updatedheader = header;
  let AI_Phone = AI_Phone_Slug.includes(slug);
  let second_Phone = second_Phone_Slug.includes(slug);
  const isPhoneNumber = AI_Phone || second_Phone;

  if (AI_Phone) {
    updatedheader = {
      ...header,
      CTA: {
        ...header?.CTA,
        text: "+91-8062500920",
        href: "tel:+918062500920",
        gaEvents: () => {
          pushToDataLayer({
            event: "call_now_clicked",
            cta_text: "Call Now",
            page_type: "Campaign Page",
            section_name: "Header",
            page_url: window.location.href,
          });
        },
      },
    };
  } else if (second_Phone) {
    updatedheader = {
      ...header,
      CTA: {
        ...header?.CTA,
        text: "+91-9711619073",
        href: "tel:+91-9711619073",
        gaEvents: () => {
          pushToDataLayer({
            event: "call_now_clicked",
            cta_text: "Call Now",
            page_type: "Campaign Page",
            section_name: "Header",
            page_url: window.location.href,
          });
        },
      },
    };
  }
  const pathName = usePathname();
  const modalDispatch = useModalDispatch();
  // CMS page-prefix logo (commonData.Header), resolved against the server slug
  // so it does not depend on the client router path; legacy campaign logo stays
  // as the fallback, then the bundled Amity logo.
  const cmsLogo = useHeaderLogo(slug ? `/${slug}` : undefined);
  const legacyLogoUrl = header?.Logo?.source?.data?.[0]?.attributes?.url;
  const logoUrl = cmsLogo?.src || legacyLogoUrl || IMAGE_ASSETS.amityLogoHeader;
  const logoAlt = cmsLogo?.alt || header?.Logo?.alt || "Amity University Online";

  useEffect(() => {
    pushToDataLayer({
      event: "page_type",
      page_type: getGlobalStateValue("pageType"),
    });
  }, []);

  if (!header?.enabled) return null;

  const isAfricaPage = pathName === "/africa";
  const isWebinarPage = pathName.includes("-webinar");

  const scrollToLeadForm = (scrollTo) => {
    document.getElementById(scrollTo)?.scrollIntoView({
      block: "start",
    });
  };

  const GAEventsHandler = () => {
    pushToDataLayer({
      event: "logo_click",
      section_name: "top navigation bar",
      page_type: getGlobalStateValue("pageType"),
    });
  };

  const onClickCTAHandler = () => {
    if (updatedheader?.CTA?.gaEvents) {
      updatedheader.CTA.gaEvents();
    } else {
      pushToDataLayer({
        event: "enquire_now_enroll_now_cta_click",
        cta_text: data?.CTA?.text || "NA",
        section_name: "Top Navigation Bar",
        page_type: "Campaign Page",
      });
    }
    scrollToLeadForm("#leadform");
  };

  const studentLoginhandler = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.LoginModal,
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "student_login_initiate",
        cta_text: "STUDENT LOGIN",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
      });
    }, 2500);
  };

  const CustomButtonPhone = () => {
    return (
      <>
        {isMobile ? (
          <a
            href={updatedheader?.CTA?.href || "#"}
            className={styles.btn}
            style={{ fontFamily: "none" }}
            target={"_self"}
            onClick={onClickCTAHandler}
          >
            Call Now
          </a>
        ) : (
          <button
            id="enrollnow-lp"
            onClick={onClickCTAHandler}
            className={styles.btn}
            style={isPhoneNumber ? { fontFamily: "none" } : {}}
          >
            {updatedheader?.CTA?.text}
          </button>
        )}
      </>
    );
  };

  const CustomButton = () => {
    return header?.CTA?.url?.includes("#") ? (
      <>
        {isWebinarPage ? null : isAfricaPage ? (
          <button onClick={studentLoginhandler} className={styles.studentLogin}>
            Existing Student Login{" "}
            <span className={styles.hideArrow}>
              <RightArrow className={styles.svgHover} stroke="#FFF" />
            </span>
          </button>
        ) : (
          <button
            id="enrollnow-lp"
            onClick={onClickCTAHandler}
            className={styles.btn}
          >
            {header?.CTA?.text} <RightArrowNew stroke="#1a325d" />
          </button>
        )}
      </>
    ) : (
      <a
        href={header?.CTA?.url || ""}
        className={styles.btn}
        target={header?.CTA?.target?.[0] || "_self"}
      >
        {header?.CTA?.text} &#8594;
      </a>
    );
  };

  return (
    <>
      <header
        className={cn("container", styles.header, {
          [styles.isProgramListPageHeader]: isProgramListPage,
        })}
        data-site-header
      >
        <div className={styles.headerContainer}>
          {logoUrl && header?.Logo?.enabled !== false ? (
              <img
                id="logo-lp"
                width={400}
                height={100}
                onClick={GAEventsHandler}
                src={logoUrl}
                alt={logoAlt}
                className={styles.logo}
              />
          ) : null}

          {header?.CTA?.enabled &&
            pathName !== "/isat" &&
            pathName !== "/msat" &&
            pathName !== "/msat-thankyou" ? (
            isPhoneNumber ? <CustomButtonPhone /> : <CustomButton />
          ) : null}
        </div>
      </header>

      {templateType === "template1" ? (
        !isEnrollNowDisabled && !isProgramListPage ? (
          <EnrollNowButton
            associatedPrograms={headerFooterData?.headerMenu?.associatedPrograms || []}
          />
        ) : null
      ) : (
        <DownloadCTASticky
          webinar={webinar}
          isPhoneNumber={isPhoneNumber}
          updatedheader={updatedheader}
          isWebinar={isWebinarPage}
          associatedPrograms={headerFooterData?.headerMenu?.associatedPrograms || []}
        />
      )}
    </>
  );
}
